<script>
  export let title, disabled, clickAction, style;
</script>

<button
  class="btn"
  {style}
  {disabled}
  on:click={(e) => {
    e.preventDefault();
    clickAction();
  }}><slot>{title}</slot></button
>

<style>
  .btn {
    appearance: none;
    /* background: #fff; */
    background: var(--color, var(--blue));
    border: 0.05rem solid var(--color, var(--blue));
    border-radius: 0.1rem;
    /* color: var(--color, var(--blue)); */
    color: #fff;
    cursor: pointer;
    display: inline-block;
    /* height: 2.25rem; */
    /* line-height: 1.2rem; */
    outline: none;
    padding: 0.5rem 0.75rem;
    text-align: center;
    text-decoration: none;
    transition: background 0.2s, border 0.2s, box-shadow 0.2s, color 0.2s;
    user-select: none;
    vertical-align: middle;
    white-space: nowrap;
  }

  .btn:focus {
    box-shadow: 0 0 0 0.1rem rgba(87, 85, 217, 0.2);
  }

  .btn:focus,
  .btn:hover {
    background: var(--color, var(--blue));
    border-color: var(--color, var(--blue));
    text-decoration: none;
  }

  .btn[disabled],
  .btn:disabled,
  .btn.disabled {
    cursor: default;
    opacity: 0.5;
    pointer-events: none;
    background: #fff;
    color: var(--color, var(--blue));
  }
</style>
